export default class CompareDate {
	constructor(parents) {
		this.parents = document.querySelectorAll(parents);
	}

	init() {
		if (!this.parents.length) {
			return;
		}

		const today = new Date(Date.now());
		today.setHours(0, 0, 0, 0);

		//console.log(today);

		[...this.parents].forEach((parent) => {
			const items = parent.querySelectorAll('[data-date]');

			const selected = [...items].find((item) => {
				const itemDate = item.dataset.date;

				if (!itemDate) {
					return false;
				}

				const targetDate = new Date(itemDate);
				targetDate.setHours(0, 0, 0, 0);

				return targetDate >= today;

				//簡単な確認用として今日の時点で非表示にする
				//return targetDate > today;
			});

			parent.innerHTML = '';

			if (selected) {
				parent.appendChild(selected);
			} else {
				parent.innerHTML = `<p>現在、${parent.dataset.tabContentName}はありません。</p>`;
			}
		});
	}
}
